// extracted by mini-css-extract-plugin
export var label = "_fs-2";
export var slideContainer = "_fs-0";
export var slider = "_fs-1";